module.exports = __webpack_public_path__ + "static/media/img-01.bc0d3485.jpg";